import { CONSTANTS__client } from '@/constants/CONSTANTS__client';
import { ELocalStorageKey } from '@/enums/ELocalStorageKey';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { ENUM__language_type } from '@shared/enums/ENUM__language_type';
import { loge, logi } from '@shared/utils/utils_logs';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

export const init_i18n = async () => {
  // Dynamic imports for all translation files
  const translationFiles = import.meta.glob('@/locales/**/*.yaml', { eager: true });

  // Process translation files into resources structure
  let resources = Object.entries(translationFiles).reduce((acc: any, [path, module]) => {
    // Extract language and namespace from path
    const matches = path.match(/\/locales\/([^/]+)\/(?:.+\/)?([^/]+)\.yaml$/);
    if (!matches) return acc;

    const [, lang, filename] = matches;
    const namespace = filename.replace('i18n_', '');

    // Initialize language if not exists
    if (!acc[lang]) {
      acc[lang] = {};
    }

    acc[lang][namespace] = module;

    return acc;
  }, {});

  resources = JSON.parse(JSON.stringify(resources));

  await i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources,
      fallbackLng: ENUM__language_type.ENGLISH,
      supportedLngs: [...CONSTANTS__client.SUPPORTED_LANGUAGES, ENUM__language_type.EMPTY, ENUM__language_type.PIGDOG],
      load: 'languageOnly',
      debug: true,
      interpolation: {
        escapeValue: true,
      },
      detection: {
        order: ['cookie', 'localStorage', 'navigator'],
        caches: ['cookie'],
        lookupLocalStorage: ELocalStorageKey.LANGUAGE,
        lookupCookie: CONSTANTS__shared.COOKIE_LANGUAGE,
      },
    });

  i18n.on('loaded', () => logi('🔤 Translations loaded successfully'));
  i18n.on('failedLoading', (language, namespace, message) => loge(`failed to load ${language}/${namespace}:${message}`));
  i18n.on('languageChanged', language => {
    logi(`🌐 language\t\t${language}`);
  });
};

export default i18n;
